import { render, staticRenderFns } from "./SiswaForm.vue?vue&type=template&id=7aa114e0"
import script from "./SiswaForm.vue?vue&type=script&lang=js"
export * from "./SiswaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports